import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Redirect } from 'react-router-dom';
import FormattedDate from './FormattedDate';
import RelayFlag from "./RelayFlag";
import ExitPolicySummary from "./ExitPolicySummary";
import RelayFamily from "./RelayFamily";
import RelayBandwidth from "./RelayBandwidth";
import RelayCountry from "./RelayCountry";
import AddressList from "./AddressList";
import { Search } from "react-bootstrap-icons";
import { Link } from 'react-router-dom';
import "bootstrap/js/src/collapse.js";

function onionooDetailsURL(query) {
  var url = "https://onionoo.torproject.org/details?";
  url += "limit=1";
  url += "&search=" + encodeURIComponent(query).replace("%3A", ":");
  return url;
}


class RelayDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      details: null,
    };
  }

  updateResults(query, limit, page) {
    fetch(onionooDetailsURL(query))
      .then(response => response.json())
      .then(data => this.setState({'details': data}));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search !== this.props.search)
      this.updateResults(nextProps.search, nextProps.limit, 1);
  }

  componentDidMount() {
    this.updateResults(this.props.search);
  }

  serverType() {
    if (!this.state.details)
      return "loading";
    if (this.state.details.relays.length === 0
      && this.state.details.bridges.length === 0)
      return "none";
    if (this.state.details.relays_truncated
      || this.state.details.bridges_truncated)
      return "multiple";
    if (this.state.details.relays.length > 0)
      return "relay";
    else
      return "bridge";
  }

  render() {
    const type = this.serverType();
    let server;
    let fingerprint;
    if (type === "loading") {
      return (
        <Container>Loading...</Container>
      );
    } else if (type === "none") {
      return (
        <Container>404 Not Found</Container>
      );
    } else if (type === "multple") {
      return (
        <Redirect to={`/search/${this.props.search}`} />
      )
    } else if (type === "relay") {
      server = this.state.details.relays[0];
      fingerprint = server.fingerprint;
    } else {
      server = this.state.details.bridges[0];
      fingerprint = server.hashed_fingerprint;
    }
    return (
      <Container>
        <Row>
          <Col>
            <h1>Relay Search</h1>
            <h2>Details for: {server.nickname}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>Configuration</h3>
            <dl>
              <dt>Nickname</dt>
              <dd>{server.nickname}</dd>
              <dt>OR Addresses</dt>
              <dd>
                <AddressList addresses={server.or_addresses} />
              </dd>
              <dt>Contact</dt>
              <dd>{server.contact}</dd>
              <dt>Dir Address</dt>
              <dd><pre>{server.dir_address}</pre></dd>
              {server.exit_addresses && (
                <>
                  <dt>Exit Addresses</dt>
                  <dd>
                    <AddressList addresses={server.exit_addresses} />
                  </dd>
                </>
              )}
              <dt>Advertised Bandwidth</dt>
              <dd>
                <RelayBandwidth
                  advertised_bandwidth={server.advertised_bandwidth}
                  bandwidth_rate={server.bandwidth_rate}
                  bandwidth_burst={server.bandwidth_burst}
                  observed_bandwidth={server.observed_bandwidth}
                />
              </dd>
              {server.exit_policy_summary && ( <>
                <dt>IPv4 Exit Policy Summary</dt>
                <dd>
                  <ExitPolicySummary
                    summary={server.exit_policy_summary || {}} />
                </dd>
              </> )}
              {server.exit_policy_v6_summary && ( <>
                <dt>IPv6 Exit Policy Summary</dt>
                <dd>
                  <ExitPolicySummary
                    summary={server.exit_policy_v6_summary || {}} />
                </dd>
              </> )}
              <dt>Exit Policy</dt>
              <dd>
                <pre className="pre-scrollable">
                  {server.exit_policy && server.exit_policy.map((value, index) => (
                    <span
                      key={index}
                      className={"text-" + ((value.includes("accept")) ? "success" : "danger")}
                    >{value}<br /></span>
                  ))}
                </pre>
              </dd>
              {server.effective_family && server.effective_family.length > 1 && (
                <>
                  <dt>
                    {"Effective Family Members "}
                    <Link to={"/search/family:" + fingerprint}>
                      <Search />
                    </Link>
                  </dt>
                  <dd>
                    <RelayFamily family={
                      server.effective_family.filter((f) => f !== fingerprint)
                    } />
                  </dd>
                </>
              )}
              {server.alleged_family && (
                <>
                  <dt>Alleged Family Members</dt>
                  <dd>
                    <RelayFamily family={server.alleged_family} />
                  </dd>
                </>
              )}
              {server.indirect_family && (
                <>
                  <dt>Indirect Family Members</dt>
                  <dd>
                    <RelayFamily family={server.indirect_family} />
                  </dd>
                </>
              )}
            </dl>
          </Col>
          <Col>
            <h3>Properties</h3>
            <dl>
              <dt>Fingerprint</dt>
              <dd><pre>{fingerprint}</pre></dd>
              <dt>{server.running ? "Uptime" : "Downtime"}</dt>
              <dd className={server.running ? "text-success" : "text-danger"}>
                {server.running
                  ? <FormattedDate full="true" date={server.last_restarted} />
                  : <FormattedDate full="true" date={server.last_seen} />}
              </dd>
              <dt>{server.running ? "Flags" : "Last Flags"}</dt>
              <dd>
                {server.flags.map((flag) => (
                  <RelayFlag
                    flag={flag}
                    text="true"
                    key={flag}
                  />
                ))}
              </dd>
              <dt>Additional Flags</dt>
              <dd>(todo)</dd>
              {server.verified_host_names && (
                <>
                  <dt>Host Name</dt>
                  <dd>
                    <AddressList addresses={server.verified_host_names} />
                  </dd>
                </>
              )}
              <dt>Country</dt>
              <dd>
                <RelayCountry
                  country={server.country || "zz"}
                  name={server.country_name || "Unknown"}
                  text="true" />
              </dd>
              <dt>Autonomous System</dt>
              <dd>{server.as_name ? server.as + ": " + server.as_name : "Unknown"}</dd>
              <dt>First Seen</dt>
              <dd>{server.first_seen}</dd>
              <dt>Consensus Weight</dt>
              <dd>{server.consensus_weight}</dd>
              <dt>Platform</dt>
              <dd>{server.platform}</dd>
            </dl>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default RelayDetails;
